import React from 'react';
import useDevice, { Device } from '../../hooks/device.hooks';
import slugify from '../../util/slugify';
import { OverviewLayoutSectionProps } from '../OverviewLayout/OverviewLayoutSection';
import NavigationDesktop from './NavigationDesktop';
import { NavigationLinkProps } from './NavigationLink';
import NavigationMobile from './NavigationMobile';

interface NavigationProps {
  sections: React.ReactElement<OverviewLayoutSectionProps>[];
}

const Navigation: React.FC<NavigationProps> = ({ sections }) => {
  const [links, setLinks] = React.useState<NavigationLinkProps[]>([]);
  const device = useDevice();

  React.useEffect(() => {
    const result: NavigationLinkProps[] = [];

    React.Children.forEach(sections, (section) => {
      if (!section.props.title) return;

      result.push({
        label: section.props.title,
        href: `#${slugify(section.props.title)}`,
      });
    });

    setLinks(result);
  }, [sections]);

  return (
    <>
      {device === Device.DESKTOP && <NavigationDesktop links={links} />}
      {device === Device.MOBILE && <NavigationMobile links={links} />}
    </>
  );
};

export default Navigation;
